module.exports = __webpack_public_path__ + "images/db-logos/corporate_memory.png";